import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { IonButton } from '@ionic/angular/standalone';

import { IconNames } from '../../../shared';
import { SvgIconComponent } from '../../icons/svg-icon/svg-icon.component';

@Component({
    selector: 'lib-icon-button',
    standalone: true,
    imports: [IonButton, SvgIconComponent, CommonModule],
    templateUrl: './icon-button.component.html',
    styleUrl: './icon-button.component.css'
})
export class IconButtonComponent {
    /* eslint-disable */
    @Input() iconName: IconNames | undefined = undefined;
    @Input() color!: string;
    @Input() borderColor!: string;
    @Input() rippleColor!: string;
    @Input() backgroundColor!: string;
    @Input() backgroundHoverColor!: string;
    @Input() backgroundFocusedColor!: string;
    @Input() border: boolean = false;
    @Input() disabled: boolean = false;
    @Input() useFillAsStrokeColor: boolean = false;
    @Input() size!: number;
    @Input() buttonSize!: number | undefined;
    @Input() display: 'circle' | 'square' = 'circle';
    @Input() preventClickPropagation: boolean = true;

    @Output() onClick = new EventEmitter();

    constructor() {}

    @HostListener('click', ['$event']) click($event: PointerEvent) {
        if (this.preventClickPropagation) {
            $event.stopPropagation();
            $event.preventDefault();
        }
    }

    onButtonClick() {
        if (this.disabled) return;
        this.onClick.emit();
    }
}
